export default "__VITE_ASSET__DdB9UKml__"